<template>
  <v-app>
    <v-container fluid grid-list-lg>
        <v-card>          
          <v-app-bar flat>
            <v-icon>new_releases</v-icon>
            <v-toolbar-title class="font-weight-light">&nbsp;ABM de Motivos Prospecto</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{on}">
                <v-btn text icon color="red" v-on="on" @click="setStatusTareaFrecuente(action)">
                  <v-icon v-if="action.esFrecuente">favorite</v-icon>
                  <v-icon v-else>favorite_border</v-icon>
                </v-btn>
              </template>
              <span v-if="action.esFrecuente">Quitar de Tareas Frecuentes</span>  
              <span v-else>Agregar a Tareas Frecuentes</span>  
            </v-tooltip>
          </v-app-bar>
          <v-card-text>
            <v-layout  wrap >               
                <v-flex xs12 sm6 md6 lg6>
                  <v-card>
                    <v-app-bar flat dense :color="$store.state.UiColors.crudToolbarList">
                      <v-icon>list</v-icon>
                      <v-toolbar-title class="font-weight-light">Lista</v-toolbar-title>
                      <v-spacer></v-spacer>                      
                    </v-app-bar>

                    <v-flex right>
                      <v-text-field
                          v-model="search"
                          append-icon="search"
                          label="Buscar por Descripción"
                          single-line
                          hide-details
                      ></v-text-field>
                    </v-flex>

                    <v-data-table 
                      :headers="headers"
                      :items="records"
                      :server-items-length="totalItems"
                      :loading="loading"
                      :options.sync="options"
                      v-model="selectedRow"
                      :footer-props="{itemsPerPageOptions:options.rowsPerPageItems}"
                    >
                      <template slot="no-data">
                        <v-alert :value="true" color="grey" icon="warning">
                          No se encontraron datos
                        </v-alert>
                      </template>
                      <template v-slot:item="{ item }">
                          <tr @click="viewItem(item)">
                            <td class="text-xs-left">{{ item.descripcion }}</td>
                            <td class="text-xs-left">                
                              <v-icon small class="mr-2" @click="editItem(item)" v-show="canUpdate">edit</v-icon>
                              <v-icon small  @click="deleteItem(item)" v-show="canDelete">delete</v-icon>
                            </td>
                          </tr>
                      </template>
                    </v-data-table>
                  </v-card >
                </v-flex>
                <v-flex xs12 sm6 md6 lg6>
                  <v-card >
                    <v-app-bar flat dense :color="$store.state.UiColors.crudToolbarDetail">
                      <v-icon>new_releases</v-icon>
                      <v-toolbar-title class="font-weight-light">Detalle</v-toolbar-title>
                      <v-spacer></v-spacer>
                      
                      <v-btn v-if="!editMode" :color="$store.state.UiColors.crudToolbarDetailButtons" fab small top @click="editItem()" v-show="canCreate">                        
                        <v-icon  medium>add_circle_outline</v-icon>
                      </v-btn>
                      
                      <v-btn v-if="model.id != null" :color="$store.state.UiColors.crudToolbarDetailButtons" fab small top @click="editMode = !editMode" v-show="canUpdate">
                        <v-icon v-if="editMode">cancel</v-icon>
                        <v-icon v-else>edit</v-icon>
                      </v-btn>
                    </v-app-bar>
                    <v-card-text>
                      <v-form :disabled="!editMode">
                          <v-layout>
                              <v-flex xs6>
                                  <v-text-field v-model="model.descripcion" label="Descripcion" required :disabled="!editMode" v-validate="'required'" data-vv-name="descripcion" :error-messages="errors.collect('descripcion')"></v-text-field>
                              </v-flex>         
                          </v-layout>
                          
                          <v-divider></v-divider>
                          <template v-if="$store.state.debugModeOn">
                            Debug Info: <p></p>
                            
                            Model: {{model}}  <p></p>                            
                          </template>
                          <v-divider></v-divider>

                          <v-card-actions bottom>
                            <v-spacer></v-spacer> 
                            <v-btn color="success" :disabled="!editMode" @click="saveItem"><v-icon>save</v-icon>Guardar</v-btn>
                          </v-card-actions>
                        </v-form>
                    </v-card-text>
                  </v-card>
                </v-flex>
            </v-layout>
          </v-card-text>
        </v-card >
    </v-container>
</v-app>
</template>

<script>

import { http } from '@/axios'
import {
  mapGetters,
  mapMutations,
  mapActions
} from 'vuex'

export default {
  data() {
    return {
      loading: false,
      editMode: false,
      suspend: false,
      search: '', // valor para búsqueda
      options: { // definición de paginación
        sortDesc:[false],
        sortBy:[''],
        page: 1,
        itemsPerPage: 5,
        rowsPerPageItems:[5,10,20]
      },
      totalItems: 0, // va afuera de options
      headers: [ // definición de columnas
        { text: 'Descripcion', value: 'descripcion' },
        { text: 'Acciones', value: 'name', sortable: false }
      ],        
      records: [], // registros
      selectedRow: [],
      model: { } // registro para ver/editar
    };
  },
  async created() {
  },
  watch: {
    options :{
        handler(){
          this.getItems();
        },
        deep: true
    },
    search() {
        this.getItems();
    }
  },
  computed: {
    ...mapGetters(['checkCanCreate', 'checkCanUpdate', 'checkCanDelete', 'getActionFromLink']),
    canCreate: function(){
      return this.checkCanCreate(this.$route.path)
    },
    canUpdate: function(){
      return this.checkCanUpdate(this.$route.path)
    },
    canDelete: function(){
      return this.checkCanDelete(this.$route.path)
    },
    action: function(){
      return this.getActionFromLink(this.$route.path)
    }
  },
  methods: {
    ...mapMutations(["alertClear", "alertSuccess", "alertWarning", "alertError"]),
    ...mapActions(['setStatusTareaFrecuente']),
    async getItems() {
      this.loading = true
      this.$validator.reset()

      try {          
        var result = await http.get('motivosprospecto?descripcion='+this.search + '&limit='+this.options.itemsPerPage+'&page='+this.options.page+
                                    '&sortby='+this.options.sortBy+'&descending='+(this.options.sortDesc.length > 0 ? this.options.sortDesc : 'false'));

        this.records = result.list;
        this.totalItems = result.totalCount
      } catch (error) {
        // Error
        this.alertError(error)
      }
      this.loading = false
    },
    async resetState(){      
      this.$validator.reset()
      this.editMode = false;
    },
    async getItem(id) {
      this.loading = true
      this.resetState()
    
      try {
        var result = await http.get('motivosprospecto/' +id );
        
        this.model = result;
      } catch (error) {
        // Error        
        this.alertError(error)
      }
      
      this.loading = false
    },    
    async viewItem(item){
      if(this.suspend) return;

      this.selectedRow.pop()
      this.selectedRow.push(item)

      await this.getItem(item.id);
      this.editMode = false;      
    },
    async clearAndReload(){
        // Clear the data inside of the form
        this.model = {status: {}}
        this.resetState()

        // Refresco la grilla
        await this.getItems()
    },
    async editItem(item){
      this.suspend = true; // hago esto porque se dispara también el evento click del row (que llama a viewItem)
      
      if(!item)
        await this.getItem(0);
      else
        await this.getItem(item.id);
      
      this.editMode = true;
      this.suspend = false;
    },
    async cancelEdit() {
      this.editMode = false;
    },
    async saveItem() {
      const isUpdate = !(this.model.id === 0);
      
      await this.$validator.validateAll();

      if(this.errors.items.length > 0) return;

      if (isUpdate) {
        try{
          await http.put('motivosprospecto', JSON.stringify( {motivoProspecto:  this.model} ) );
          this.alertSuccess('Los cambios han sido guardados.');
          this.clearAndReload();
        } 
        catch(error){          
          // Error
          this.alertError(error)
        }               
      } else {
        try{          
          console.log(this.model)
          console.log(JSON.stringify({ motivoProspecto: this.model} ))
          await http.post('motivosprospecto', JSON.stringify( {motivoProspecto:  this.model} ) );
          this.alertSuccess('Los cambios han sido guardados.')
          this.clearAndReload();
        } 
        catch(error){
          // Error          
          this.alertError(error)
        }         
      }
    },
    async deleteItem(item) {      
      if (confirm('¿Confirma la eliminación del Motivo ' + item.descripcion + '?')) {
        try{            
            await http.delete('motivosprospecto?id='+item.id );
            this.alertSuccess('El Motivo de Prospecto ha sido eliminado.')
            this.clearAndReload();
        }
        catch(error){
          // Error
          this.alertError(error)
        }
      }
    }
  }
}
</script>